import tw, { styled } from 'twin.macro';

export const BannerWrapper = styled.div`
${tw`fixed bottom-0 left-0 right-0 flex items-center justify-between gap-5 px-4 py-2.5`};
  background-image: url(https://storage.googleapis.com/fplsblog/Form_error_images/form_error_background.png);
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.08);
  font-family: inter !important;
  border-top: 1px solid #ddd;
  background-color: whitesmoke;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  z-index: 1000;
`;

export const LogoBox = styled.div`
  flex-shrink: 0;

  img {
    width: 85px;
    height: auto;
  }
`;

export const ContentBox = styled.div`
  ${tw`flex items-center gap-4`};

  p {
    ${tw`m-0 text-xs md:text-sm hidden md:block`};
    font-family: inter !important;
    font-weight: 500;
    color: #1a2e44;
  }

  a {
    ${tw`px-4 py-2.5 md:px-10 text-xs md:text-sm`};
    background: linear-gradient(270deg, #1a8caf, #00afbf);
    transition: background 0.2s ease;
    font-family: inter !important;
    align-self: flex-start;
    text-decoration: none;
    border-radius: 3px;
    font-weight: 900;
    color: #fff;
  }
`;